// extracted by mini-css-extract-plugin
module.exports = {"TeamFeed":"styles_TeamFeed__aeoZt","bg_1":"styles_bg_1__HmsaC","bg_2":"styles_bg_2__gP8a2","height":"styles_height__f1rFz"};